(function () {
  var input = document.querySelector('[data-skinctionary-search]');
  if (!input) return;

  var entries = Array.prototype.slice.call(document.querySelectorAll('[data-skinctionary-entry]'));
  var groups = Array.prototype.slice.call(document.querySelectorAll('[data-skinctionary-group]'));
  var noResults = document.querySelector('[data-skinctionary-no-results]');

  input.addEventListener('input', function () {
    var query = input.value.trim().toLowerCase();
    var visibleCount = 0;

    entries.forEach(function (entry) {
      var name = entry.getAttribute('data-name') || '';
      var matches = query === '' || name.indexOf(query) !== -1;
      entry.hidden = !matches;
      if (matches) visibleCount++;
    });

    // A letter with no matching entries left would otherwise sit there as a
    // bare rule and numeral.
    groups.forEach(function (group) {
      var stillVisible = group.querySelector('[data-skinctionary-entry]:not([hidden])');
      group.hidden = !stillVisible;
    });

    if (noResults) {
      noResults.hidden = visibleCount !== 0;
    }
  });
})();
